import React, { ChangeEvent, FC, ForwardedRef, forwardRef } from 'react';
import cn from 'classnames';

import lineIcon from '../../../imgs/imagesHeader/Line.svg';

// const lineIcon = require('');
const Checkbox: FC<{
  checked?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  touched?: boolean;
  disabled?: boolean;
  className?: string;
  label?: string;
}> = forwardRef((props, ref: ForwardedRef<HTMLInputElement>) => {
  const { checked, onChange, touched, className, disabled, label, ...rest } = props;
  const checkboxClassName = cn(
    'form-check-input',
    'ring-none',
    'outline-0',
    'appearance-none',
    'h-3',
    'w-3',
    'border',
    'border-gray-300',
    'rounded-sm',
    touched && !checked ? 'bg-action' : 'bg-white',
    'checked:bg-action',
    'checked:border-action',
    'focus:outline-none',
    'transition',
    'duration-200',
    'align-top',
    'bg-no-repeat',
    'bg-center',
    'bg-contain',
    'float-left',
    'cursor-pointer',
    className ? className : '',
  );
  return (
    <div className="flex items-center gap-[8px]">
      <input
        ref={ref}
        className={checkboxClassName}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        style={
          touched && !checked
            ? {
                backgroundImage: `linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)), url(${lineIcon})`,
                backgroundSize: '2px 70%',
                rotate: '90deg',
                backgroundRepeat: 'no-repeat',
                border: 'none',
              }
            : {}
        }
        onChange={(e) => onChange?.(e)}
        {...rest}
      />
      {label && (
        <div className="text-[13px] font-[700] text-2color leading-[109%] tracking-[-0.03em]">
          {label}
        </div>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
